<div class="layout-vbox" style="height: 100%; gap: 4px">
    <h4>
        MCP Connector
    </h4>

    <div class="toolbar-horizontal">
        <span>ID: {{mcpAdapter.sessionId}}</span>
        <fluent-button (click)="onCopyPromptToClipboard()" title="Copy AI Prompt"><i class="far fa-copy"></i></fluent-button>
    </div>

    <div style="width: 100%; flex: 1; overflow: hidden">
        <wj-flex-grid #grid style="height: 100%" [isReadOnly]="true" headersVisibility="Column" selectionMode="Row"
                      [itemsSource]="messages"
        >
            <wj-flex-grid-column [header]="'#'" [binding]="'number'" [width]="20" align="center"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'D'" [binding]="'direction'" [width]="20" align="center"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Type'" [binding]="'type'" [width]="60"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Content'" [binding]="'data'" [width]="'*'"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>

    <div class="toolbar">
        <fluent-button (click)="onConnect()">Connect</fluent-button>
        <fluent-button (click)="onDisconnect()">Disconnect</fluent-button>
    </div>

</div>

